import {
    MAKSLENGDER,
    validateFodselsnummer,
    validateIsNonEmptyText,
    validateMobilnummer,
} from '../validation/validate';
import { CurrentSimpleKontaktinfosporsmal } from './simpleKontaktinfo-types';

export enum SimpleKontaktinfofelt {
    FulltNavn = 'FULLT_NAVN',
    Mobilnummer = 'MOBILNUMMER',
    Personnummer = 'FODSELSNUMMER',
}

export const getFeilmeldingFrom = (type: SimpleKontaktinfofelt) => {
    switch (type) {
        case SimpleKontaktinfofelt.FulltNavn:
            return `Fullt navn må ha en verdi og kan ikke være mer enn ${MAKSLENGDER.fornavn} tegn.`;
        case SimpleKontaktinfofelt.Mobilnummer:
            return 'Vi trenger et norsk mobilnummer (8 siffer).';
        case SimpleKontaktinfofelt.Personnummer:
            return 'Her mangler det et gyldig fødselsnummer. Fødselsnummer består av fødselsdato (DDMMÅÅ) og personnummer (5 siffer)';
        default:
            return '';
    }
};

export const removeSpaces = (value: string) => value.replace(/ /g, '');

export const isValid = (kontaktinfoSvar: CurrentSimpleKontaktinfosporsmal, type: SimpleKontaktinfofelt) => {
    switch (type) {
        case SimpleKontaktinfofelt.FulltNavn:
            return validateIsNonEmptyText(kontaktinfoSvar.fulltNavn);
        case SimpleKontaktinfofelt.Mobilnummer:
            return validateMobilnummer(kontaktinfoSvar.mobilnummer);
        case SimpleKontaktinfofelt.Personnummer:
            return validateFodselsnummer(kontaktinfoSvar.fodselsnummer);
        default:
            return true;
    }
};

export const isSimpleKontaktinfoValid = (kontaktinfoSvar: CurrentSimpleKontaktinfosporsmal) =>
    isValid(kontaktinfoSvar, SimpleKontaktinfofelt.FulltNavn) &&
    isValid(kontaktinfoSvar, SimpleKontaktinfofelt.Mobilnummer) &&
    isValid(kontaktinfoSvar, SimpleKontaktinfofelt.Personnummer);
